import { Component, ViewEncapsulation} from '@angular/core';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class BreadcrumbsComponent   {
  public currentMenuItem = 'Route planner';
  constructor(public _appUtilityService: AppUtilityService) { }


}
